// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { DateRange } from '@mui/x-date-pickers-pro';
import { DateTime } from 'luxon';

export interface DateRangeShortcut {
  label: string;
  getDateRange: (today: DateTime) => DateRange<DateTime>;
}

export const DATE_RANGE_SHORTCUT_THIS_MONTH: DateRangeShortcut = {
  label: 'This month',
  getDateRange: (today) => {
    const startOfMonth = today.startOf('month');

    return [startOfMonth, DateTime.max(startOfMonth, today.minus({ days: 1 }))];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_MONTH_TO_DATE: DateRangeShortcut = {
  label: 'Last month to date',
  getDateRange: (today) => {
    return [today.minus({ days: 31 }), today.minus({ days: 1 })];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_FULL_MONTH: DateRangeShortcut = {
  label: 'Last full month',
  getDateRange: (today) => {
    return [
      today.startOf('month').minus({ months: 1 }),
      today.startOf('month').minus({ days: 1 }),
    ];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_30_DAYS: DateRangeShortcut = {
  label: 'Last 30 days',
  getDateRange: (today) => {
    return [today.minus({ days: 30 }), today.minus({ days: 1 })];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_60_DAYS: DateRangeShortcut = {
  label: 'Last 60 days',
  getDateRange: (today) => {
    return [today.minus({ days: 60 }), today.minus({ days: 1 })];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_90_DAYS: DateRangeShortcut = {
  label: 'Last 90 days',
  getDateRange: (today) => {
    return [today.minus({ days: 90 }), today.minus({ days: 1 })];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_180_DAYS: DateRangeShortcut = {
  label: 'Last 180 days',
  getDateRange: (today) => {
    return [today.minus({ days: 180 }), today.minus({ days: 1 })];
  },
};

export const DATE_RANGE_SHORTCUT_LAST_365_DAYS: DateRangeShortcut = {
  label: 'Last 365 days',
  getDateRange: (today) => {
    return [today.minus({ days: 365 }), today.minus({ days: 1 })];
  },
};
